import { useEffect, useState } from 'react'

interface TypewriterOptions {
  texts: string[]
  /** 每个 tick 的毫秒数 */
  typeInterval?: number
  /** 打满后停留多少个 tick 再开始删除 */
  pauseTicks?: number
  /** 删除阶段每个 tick 删掉几个字符 */
  eraseStep?: number
  /** 是否启用打字机 */
  enabled?: boolean
}

/** 打字机循环：逐字打出 → 停留 → 快速删除 → 切换下一条 */
export function useTypewriter({
  texts,
  typeInterval = 100,
  pauseTicks = 20,
  eraseStep = 2,
  enabled = true,
}: TypewriterOptions) {
  const [text, setText] = useState('')
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (!enabled) {
      setText('')
      return
    }

    let charCount = 0
    let erasing = false
    let pause = 0
    let current = 0

    const timer = setInterval(() => {
      const full = texts[current]

      if (!erasing) {
        if (charCount < full.length) {
          charCount++
          setText(full.slice(0, charCount))
        } else if (++pause > pauseTicks) {
          erasing = true
          pause = 0
        }
      } else if (charCount > 0) {
        charCount = Math.max(0, charCount - eraseStep)
        setText(full.slice(0, charCount))
      } else {
        erasing = false
        current = (current + 1) % texts.length
        setIndex(current)
      }
    }, typeInterval)

    return () => clearInterval(timer)
  }, [texts, typeInterval, pauseTicks, eraseStep, enabled])

  return { text, index }
}
